import { useEffect, useState } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import HomePage from "@/pages/HomePage";
import ShopPage from "@/pages/ShopPage";
import ProductDetailPage from "@/pages/ProductDetailPage";
import WarrantyPage from "@/pages/WarrantyPage";
import ContactPage from "@/pages/ContactPage";
import PrivacyPage from "@/pages/PrivacyPage";
import TermsPage from "@/pages/TermsPage";
import ReturnPolicyPage from "@/pages/ReturnPolicyPage";
import AdminPage from "@/pages/AdminPage";
import { fetchSiteSettings } from "@/lib/api";

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => { window.scrollTo(0, 0); }, [pathname]);
  return null;
}

function AppContent() {
  const [settings, setSettings] = useState({
    business_name: "PennyMacs",
    phone: "",
    email: "",
    address: "",
    hours: "",
  });
  const { pathname } = useLocation();
  const isAdmin = pathname.startsWith("/admin");

  useEffect(() => {
    fetchSiteSettings().then((res) => setSettings(res.data)).catch(() => {});
  }, []);

  return (
    <div className="flex flex-col min-h-screen">
      <ScrollToTop />
      {!isAdmin && <Header settings={settings} />}
      <main className="flex-1">
        <Routes>
          <Route path="/" element={<HomePage settings={settings} />} />
          <Route path="/shop" element={<ShopPage />} />
          <Route path="/product/:id" element={<ProductDetailPage settings={settings} />} />
          <Route path="/warranty" element={<WarrantyPage />} />
          <Route path="/contact" element={<ContactPage settings={settings} />} />
          <Route path="/privacy" element={<PrivacyPage settings={settings} />} />
          <Route path="/terms" element={<TermsPage settings={settings} />} />
          <Route path="/return-policy" element={<ReturnPolicyPage settings={settings} />} />
          <Route path="/admin/*" element={<AdminPage settings={settings} onSettingsUpdate={setSettings} />} />
        </Routes>
      </main>
      {!isAdmin && <Footer settings={settings} />}
      <Toaster position="top-right" richColors />
    </div>
  );
}

function App() {
  return (
    <BrowserRouter>
      <AppContent />
    </BrowserRouter>
  );
}

export default App;
